<!--Start Back To Top Button-->
<!-- <a href="#" (click)="$event.preventDefault()" class="back-to-top"><i class='bx bxs-up-arrow-alt'></i></a> -->
<!--End Back To Top Button-->
<!--footer -->
<footer class="bg-dark text-white pt-2 pb-5" style="cursor: pointer;    margin-top: 12%;">
  <div class=" text-md-left">
    <div class="row text-md-left">
      <div class="col-md-4 col-lg-2 col-xl-2 mx-auto">
        <h5 class="text-white font-weight-bold mt-3 mb-4" style="cursor: default;">General Information</h5>
        <div *ngFor="let item of footerDetails?.GENERAL">
          <p [routerLink]="['/resources', item.slug]" style="color:
          #BBBBBB;" >
         {{ item.title}}
          </p>
         </div>
        <!-- <p [routerLink]="['/pricing']">
          <a class="text-left" style="text-decoration: none; color:
          #BBBBBB;">Pricing and payment</a>
        </p>
        <p>
          <a [routerLink]="['/credit-cards']" class="text-left" style="text-decoration: none; color: 
          #BBBBBB;">Credit card</a>
        </p>
        <p [routerLink]="['/privacy-right']">
          <a  class="text-left" style="text-decoration: none; color:
          #BBBBBB;">Your Privacy Rights</a>
        </p>
        <p [routerLink]="['/location']">
          <a  class="text-left" style="text-decoration: none; color:
          #BBBBBB;">Location</a>
        </p> -->

      </div>

      <div class="col-md-4 col-lg-2 col-xl-2">
        <h5 class="font-weight-bold mt-3 mb-4" style="cursor: default;">Customer Service</h5>
       <div *ngFor="let item of footerDetails?.CUSTOMER">
        <p [routerLink]="['/resources', item.slug]" style="color:
        #BBBBBB;" >
       {{ item.title}}
        </p>
       </div>
        <!-- <p style="color:
        #BBBBBB;" [routerLink]="['/order-hours']">
        Order Hours
        </p>
        <p style="color:
        #BBBBBB;"  [routerLink]="['/get-reminders']">
       Get Reminders from our
       Office
        </p> -->
      </div>

      <div class="col-md-4 col-lg-2 col-xl-2">
        <h5 class="font-weight-bold mt-3 mb-4" style="cursor: default;">Ordering Information</h5>
        <p [routerLink]="['/resources', data?.slug]"  *ngFor="let data of footerDetails?.ORDER">
          <a  style="color:
          #BBBBBB; text-decoration: none;">{{data.title}}</a>
        </p>
  
      </div>
      <div class="col-md-4 col-lg-2 col-xl-2">
        <h5 class="font-weight-bold mt-3 mb-4" style="cursor: default;">Delivery Information</h5>
        <p [routerLink]="['/resources', data?.slug]"*ngFor="let data of footerDetails?.DELIVERY">
          <a  style="color:
          #BBBBBB; text-decoration: none;">{{data.title}}</a>
        </p>
        <!-- <p [routerLink]="['/blog']" >
          <a  style="color: 
          #BBBBBB; text-decoration: none;">Blog</a>
        </p> -->
      </div>

      <div class="col-md-8 col-lg-3 col-xl-3">
        <h5 class="font-weight-bold mt-3 mb-4" style="cursor: default;">Contact Us</h5>
       <div class="d-flex">
        <p class="d-flex mb-2">
          <i class="bx bxs-map" style="color:#F44C4C;width:18px;cursor: default;"></i>
          <label style="
          margin-left: 11px;
      ">Address:</label>
          <p class="text-left mr-3" style="margin-left: 35px; color:
          #BBBBBB"> {{contact?.site_address}}</p>
       </div>

        
     <div class="d-flex">
      <p class="d-flex mb-2">
       <i class="bx bx-phone" style="color:#F44C4C;width:18px;cursor: default;"></i>
        <label style="
        margin-left: 10px; 
    ">Call Us:</label>
        <p class="text-left mr-3" style="margin-left: 35px;color:#BBBBBB">{{contact?.contact_no}}</p>
     </div>
       
      <div class="d-flex">
        <p class="d-flex mb-2">
          <i class="bx bx-envelope" style="color:#F44C4C;width:18px;cursor: default;"></i>
          <label style="margin-left:12px">Email:</label>
          <p class="text-left mr-3" style="margin-left: 34px;color:#BBBBBB"> {{contact?.admin_email}}</p>
      </div>
       

        <form [formGroup]="footeremailform">
          <div>
            <h5 class="font-weight-bold">Join Our Community</h5>
            <input type="text" class="form-control" formControlName="email" style="width: 180px;height: 37px;border-radius: 10px;border: none;" placeholder=" Email Id" class="col-xs-3"  >&nbsp;&nbsp;
            <button type="button" class="btn btn-danger btn-sm" (click)="submitcart()" style="background-color: #F44C4C;">Submit</button>
          </div>
          <mat-error>
            <span *ngIf="(submitted && footeremailform.get('email')?.errors) || !footeremailform.get('email')?.valid && footeremailform.get('email')?.touched">Please enter email </span>
        </mat-error>
        </form>

        <div class="d-flex" style="height: 40px; width: 40px; padding-top: 5px;">
          <img src="/assets/images/iosApp.png" (click)="openurl(socialmedia.appleStoreUrl)">
          <img src="/assets/images/androidApp.png"(click)="openurl(socialmedia.googlePlayStoreUrl)" >
        </div>

      </div>
    </div>

    <hr class="mb-2">
    <div class="row align-i tems-center d-flex" style="margin-bottom: -30px;">
      <div class="col-md-9 col-lg-10 col-xl-10 d-flex d-block-mb">
        <div class="text-white ps-5 t5">© 2024 Wholesale Corporation all rights reserved </div>
       <div class="d-flex d-block-mb">
     <div>
      <a class="text-white t6" [routerLink]="['/pricing','deliveryinstantsavings']" >Delivery Instant Savings | </a>
     </div>
       <div style="margin-left: 5px;">
        <p [routerLink]="['/credit-cards','warehouseinstantsavings']" >Warehouse Instant Saving</p>
       </div>
       </div>

        <!-- <div class="myclass text-md-right">
          <i class="fa fa-facebook-official" aria-hidden="true"></i>
          <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          <i class="fa fa-instagram" aria-hidden="true"></i>
          <i class="fa fa-twitter-square" aria-hidden="true"></i>
          <i class="fa fa-facebook" aria-hidden="true"></i>

        </div> -->

        <!-- <div class="col-md-5 lg-5">
          <div class="text-center text-md-right">
            <ul class="list-unstyled style-inline">
              <li class="list-inline-item">
                <a href="" class="btn-floating btn-sm text-white" style="font-size: 20px;"><i class="fa fa-facebook" aria-hidden="true"></i></a>
              </li>
            </ul>
          </div>
        </div> -->
      </div>

      <div class="col-md-3 col-lg-2 col-xl-2 lg-2">
        <div class="text-center text-md-right">
          <div class="myclass text-md-right">
            <i style="background-color: #F44C4C;" class="fa fa-facebook-official" aria-hidden="true" (click)="openurl(socialmedia.facebookUrl)"></i>
            <i style="background-color: #F44C4C;" class="fa fa-linkedin-square" aria-hidden="true" (click)="openurl(socialmedia.linkedinUrl)"></i>
            <i  style="background-color: #F44C4C;" class="fa fa-instagram" aria-hidden="true" (click)="openurl(socialmedia.instagramUrl)"></i>
            <i   style="background-color: #F44C4C;"class="fa fa-twitter-square" aria-hidden="true" (click)="openurl(socialmedia.twitterUrl)"></i>
            <!-- <i class="fa fa-facebook" aria-hidden="true"></i> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- end footer -->
